const RestrictionsFacade = require('../../../../facade/restrictions/restrictions');
const BaseView = require('../abstract-element-options');

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: async function (options) {
    this.selection = options.selection;
    const getRestrictions = _.partial(
      RestrictionsFacade.getElementRestrictions,
      this.selection.id
    );

    const basicRestrictions = getRestrictions('basic');
    if (
      !basicRestrictions[0] ||
      _.isUndefined(basicRestrictions[0].image_content)
    ) {
      basicRestrictions[0] = RestrictionsFacade.getAllDefaultPermissions();
    }

    const canReplace = basicRestrictions[0].image_content;
    const { resources, folders } = await this.getAllowedReplacements('Image');

    this.render(canReplace, resources, folders);

    options.hasOwnProperty('callback') && options.callback();
  },

  replaceItem: function (asset) {
    const getSize = async function (asset, thumb) {
      if (!asset.details?.size) {
        return Promise.resolve(null);
      }

      const canvasWidth = INKIVE.EditorFacade.canvas.contentW;
      const canvasHeight = INKIVE.EditorFacade.canvas.contentH;

      const calculateRelativeAssetSize = function (canvasSize, assetSize) {
        const SVGRatio = canvasSize.width / canvasSize.height;
        const imageRatio = assetSize.width / assetSize.height;
        const sizeLimit = 0.7;

        const width = imageRatio > SVGRatio
          ? canvasSize.width * sizeLimit
          : (canvasSize.height * sizeLimit) * imageRatio;

        const height = imageRatio > SVGRatio
          ? width / imageRatio
          : canvasSize.height * sizeLimit;

        return {
          width,
          height
        };
      };

      const getImageSize = (url) => {
        const isValidUrl = url && url.startsWith('http');
        if (!isValidUrl) return;

        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve({ width: img.width, height: img.height });
          img.onerror = reject;
          img.src = url;
        });
      };
      const {
        width, height
      } = calculateRelativeAssetSize({
        width: canvasWidth, height: canvasHeight
      }, asset.details.size);

      const imageVersionUrl = INKIVE.ImagesFactory.getRightSizeUrl(
        thumb,
        { width, height }
      );

      const fitSize = await getImageSize(imageVersionUrl);

      return {
        width: fitSize.width,
        height: fitSize.height,
        x: (canvasWidth - fitSize.width) / 2,
        y: (canvasHeight - fitSize.height) / 2
      };
    };

    if (!asset.source) {
      return;
    }

    const selectedElement = INKIVE.DesignFacade.getSelectedElements()[0];
    if (!selectedElement) {
      return;
    }

    const $element = $(selectedElement);
    const isFrame = $element.is('.sticker') && $element.find('image.subelement').length;
    const isImage = $element.is('image.element');

    if (!isFrame && !isImage) {
      return;
    }

    const selectedElemUrl = selectedElement.getAttribute('xlink:href');
    const isPlaceHolder = selectedElemUrl && /imageplaceholder_new\.svg$/.test(selectedElemUrl);
    const id = $element.closest('.background').length
      ? 'background'
      : $element.attr('id');

    INKIVE.ImagesFactory.removeImageFilter($element, asset.source);
    const thumb = asset.source ?? INKIVE.ImagesFactory.getVersionUrl(asset.source, 'thumb');

    return getSize(asset, thumb).then((size) => {
      if (size) {
        INKIVE.EditorFacade.canvas.runExtensions('addLayoutImage', {
          elem: document.getElementById(id),
          data: {
            url: asset.source,
            width: size.width,
            height: size.height
          }
        });
      }

      INKIVE.DesignFacade.set(id, {
        source: {
          preload: true,
          url: asset.source
        },
        keep_box_size: true,
        img_frame: isPlaceHolder,
        just_added: asset.details
      });

      return size;
    });
  },

  fromFolderResourceToSource: function (resource) {
    if (typeof resource === 'string') {
      return {
        source: resource,
        thumbnail: resource
      };
    }

    return resource.data.source;
  },

  render: function (canReplace, sources, folders) {
    if ((canReplace && (sources || folders))) {
      this.$el.html(this.template({}));
      this.initReplacementPanel({
        folders,
        assets: sources
      }, 'image');
    } else if (canReplace) {
      this.$el.addClass('show-images-tab');
      this.$el.data('type', 'image');
    }
  },

  remove: function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    Backbone.View.prototype.remove.call(this);
  }
});
